var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 13.958a.625.625 0 0 1-.5-1 4.95 4.95 0 0 0 0-5.916.625.625 0 0 1 1-.75 6.23 6.23 0 0 1 0 7.416.62.62 0 0 1-.5.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.525 16.042a.625.625 0 0 1-.5-1c2.225-2.967 2.225-7.117 0-10.084a.625.625 0 0 1 1-.75c2.558 3.409 2.558 8.175 0 11.584a.6.6 0 0 1-.5.25M11.683 3.15c-.933-.517-2.125-.383-3.341.375L5.908 5.05a1.1 1.1 0 0 1-.55.158H4.167c-2.017 0-3.125 1.109-3.125 3.125v3.334c0 2.016 1.108 3.125 3.125 3.125h1.191c.192 0 .384.058.55.158l2.434 1.525c.733.458 1.45.683 2.116.683.434 0 .85-.1 1.225-.308.925-.517 1.442-1.592 1.442-3.025v-7.65c0-1.433-.517-2.508-1.442-3.025"
  })));
};
export default SvgVolume;